// The world's tiniest module!

const LESS_URGENT_THAN_NORMAL = -10;

export { LESS_URGENT_THAN_NORMAL };
